(function (ws) {
    'use strict';
    ws.models.custOnboardingMdmValidation = Backbone.Model.extend({
        urlRoot: function () {
            return globals.path.api.westcon.customerOnboardingMdmValidation.replace('{prospectId}', this.get('prospectId'));
        }
    });

    var properties = {
        idAttribute: 'sapId',

        /**
         * Initializes the account.
         *
         * @param {Object} data
         */
        initialize: function (data) {
            if (typeof data === 'object') {
                this.set(data);
            }
        },

        /**
         * Formats the account as a single line address.
         * @returns {string}
         */
        toOneLine: function () {
            return ws.models.accountDetails._combine([
                ws.models.accountDetails._combine([
                    this.get('addressLine1'),
                    this.get('addressLine2'),
                    this.get('addressLine3'),
                    this.get('addressLine4'),
                    this.get('locality'),
                    this.get('town'),
                    this.get('state'),
                    this.get('zipCode')
                ], ', '),
                this.get('country').isocode
            ], ' ');
        },

        /**
         * Formats the account as a four line address, delimited by \n.
         * @returns {string}
         * @param {boolean} hideAccountNumber
         */
        toThreeLines: function (hideAccountNumber = false) {
            var lines = [
                ws.models.accountDetails._combine([
                    this.get('addressLine1'),
                    this.get('addressLine2'),
                    this.get('addressLine3'),
                    this.get('addressLine4'),
                    this.get('locality')
                ], ', '),
                ws.models.accountDetails._combine([
                    ws.models.accountDetails._combine([this.get('town'), this.get('state')], ', '),
                    this.get('zipCode'),
                    this.get('country') ? this.get('country').isocode : (this.country ? this.country.isocode : '')
                ], ' ')
            ];
            return ws.models.accountDetails._combine(lines, '\n');
        }
    };

    var classProperties = {
        /**
         * Transforms a list of components into a string,
         * removing all whitespace-only components
         * and combining each with a delimiter.
         * @param {string[]} components
         * @param {string} delimiter
         * @return {string}
         * @protected
         */
        _combine: function (components, delimiter) {
            for (var i = 0; i < components.length; i++) {
                // Remove any whitespace-only component
                if (components[i] === undefined || components[i] === null || typeof components[i] === 'string' && components[i].match(/\S/) === null) {
                    components.splice(i, 1);
                    i--;
                }
            }

            return components.join(delimiter);
        }
    };

    ws.models.accountDetails = Backbone.Model.extend(properties, classProperties);
})(westcon);
